import axios from '@/plugins/axios'

export default {
  save(data, id) {
    return id ? this.update(data, id) : this.store(data)
  },
  store(data) {
    return axios.post('/yacht-sales-slots', data)
      .then(response => response.data)
  },
  update(data, id) {
    return axios.patch(`/yacht-sales-slots/${id}`, data)
      .then(response => response.data)
  },
  fetch(params) {
    return axios.get('/yacht-sales-slots', { params: params })
      .then(response => response.data)
  },
  get(id) {
    return axios.get(`/yacht-sales-slots/${id}`)
      .then(response => response.data)
  },
  destroy(id) {
    return axios.delete(`/yacht-sales-slots/${id}`)
  }
}
